import { h, defineComponent } from 'vue';
import { pageSubtitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { capitalizeFirstLetter, monetizeString } from '@/ui/helpers';
import { currency, numberSeats, planType } from '@/services/chargebee/availablePlans';

interface SummaryProps {
  pricePerUser: number | string;
  finalCharge: number | string;
}

export const CbSummary = defineComponent<SummaryProps>({
  name: 'CbSummary',
  props: ['pricePerUser', 'finalCharge'],
  setup(props) {
    return function render() {
      return h('section', { class: 'subscribe_page__section' }, [
        pageSubtitle(t('subscription.summary')),
        h('div', { class: 'subscribe_page__summary-row' }, [
          h('div', t('subscription.billing-frequency')),
          h('div', capitalizeFirstLetter(t(`subscription.${planType.value.toString()}`))),
        ]),
        h('div', { class: 'subscribe_page__summary-row' }, [
          h('div', t('subscription.users')),
          h('div', numberSeats.value.toString()),
        ]),
        h('div', { class: 'subscribe_page__summary-row' }, [
          h('div', t('subscription.amount-per-user')),
          h('div', monetizeString(props.pricePerUser ?? '0', { currency: currency.value })),
        ]),
        h('div', { class: 'subscribe_page__summary-row' }, [
          h('div', t('subscription.amount-charged', {
            period: t(`subscription.${planType.value.toString()}`),
          })),
          h('div', { class: 'subscribe_page__final-charge' }, [
            h('div', monetizeString(props.finalCharge, { currency: currency.value })),
            h('div', { class: 'subscribe_page__vat' }, '+ VAT'),
          ]),
        ]),
      ]);
    };
  },
});
